import React, { Component } from 'react';
import { Input, Button } from '@driftt/tide-core'
import PropTypes from 'prop-types'
import { fetchApp } from 'api/developerApi'
import { updateExternalUrlEnabled, updateExternalUrl } from 'api/developerApi'
import { connect } from 'react-redux'
import { showTransientNotification } from '@driftt/traffic-control'
import { isURL } from 'validator'
import './style.css'

class AppExternalUrlView extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired
  }

  state = {
    externalUrlEnabled: false,
    isSavingExternalUrl: false,
    externalUrl: '',
    isFetchingApp: true,
    app: {}
  }

  fetchApp = () => {
    const { appId } = this.props
    const onDone = (app) => {
      this.setState({ externalUrl: app.externalUrl, externalUrlEnabled: app.externalUrlEnabled })
    }
    const onError = (error) => this.props.showErrorNotification('Ooops, something went wrong. Please refresh the page.')
    const onFinally = () => this.setState({ isFetchingApp: false })

    const onStateSet = () => fetchApp(appId)
      .then(onDone)
      .catch(onError)
      .then(onFinally)

    this.setState({ isFetchingApp: true }, onStateSet)
  }

  componentDidMount() {
    this.fetchApp()
  }

  validateUrl = (value) => {
    const constraints = { protocols: ['https'], require_protocol: true }
    return isURL(value, constraints)
  }

  onChangeExternalUrl(e) {
    this.setState({ externalUrl: e.target.value })
  }

  updateExternalUrl = () => {
    const { appId } = this.props
    const { externalUrl } = this.state
    console.log(externalUrl)
    if (!externalUrl || !this.validateUrl(externalUrl)) {
      this.props.showErrorNotification('Please enter a valid URL prefixed with https.') 
    }

    const onSuccess = () => this.setState({ externalUrl })
    const onError = (error) => this.props.showErrorNotification('We couldn’t update your public URL. Please try again.')
    const onFinally = () => this.setState({ isSavingExternalUrl: false })

    const onStateSet = () => updateExternalUrl({ appId, externalUrl })
      .then(onSuccess)
      .catch(onError)
      .then(onFinally)

    this.setState({ isSavingExternalUrl: true }, onStateSet)
  }

  updateExternalUrlEnabled = (val) => {
    const { appId } = this.props
    const externalUrlEnabled = val

    const onSuccess = () => this.setState({ externalUrlEnabled })
    const onError = (error) => this.props.showErrorNotification('We couldn’t update your public URL setting. Please try again.')

    updateExternalUrlEnabled({ appId, externalUrlEnabled })
      .then(onSuccess)
      .catch(onError)
  }

  render() {
    const { externalUrlEnabled, externalUrl, isFetchingApp, isSavingExternalUrl } = this.state

    return (
      <div className="app-external-link-view">
        <span className="app-external-link-view-page-title">
          Public Listing URL
        </span>
        <div>
          <p className="app-external-link-view-page-description">
            What redirect URL should we use for your App page? <br />
            If checked, the user can be sent to your desired page if set for initiating the app connection.
            If left unchecked, the user will be sent to your Oauth redirect url directly without a state param.
          </p>
          {!isFetchingApp && <div>
            <Input
              className="app-external-link-view-page-service"
              type="checkbox"
              onChange={(val) => this.updateExternalUrlEnabled(val)}
              checked={externalUrlEnabled}
            />

            {externalUrlEnabled && <div>
              <Input
                className="app-external-link-input"
                onChange={(val) => this.onChangeExternalUrl(val)}
                placeholder="Enter your integration page url"
                value={externalUrl}
              />

              <Button
                type="primary"
                size="medium"
                className="app-external-link-save-url-button"
                loading={isSavingExternalUrl}
                onClick={this.updateExternalUrl}>
                Save
            </Button>

            </div>}
          </div>}
        </div>
      </div>
    )
  }
}

const mapStateToProps = null
const mapDispatchToProps = dispatch => ({
  showErrorNotification: (message) => dispatch(showTransientNotification({ type: 'error', message }))
})

export default connect(mapStateToProps, mapDispatchToProps)(AppExternalUrlView)